module.exports = __webpack_public_path__ + "images/index/img01.8e83a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/aenatedu/img01.png
// module id = f08O
// module chunks = 21